//Asynchronously load a file served over HTTP(S). onSuccess is called with the contents, onFail is called with 'retrieve' or 'timeout' and the XMLHttpRequest. Timeout is in ms, 0 for no timeout.
export default function loadFile(url, onSuccess, onFail=(type)=>{console.error('JSON load failed', url, type)}, timeout=0, disableCaching=false) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.timeout = timeout;

  xmlHttp.onload = () => {
    onSuccess(xmlHttp.responseText, xmlHttp);
  }
  //xmlHttp.onabort = () => {} This might be useful later but currently aborting is not supported.
  xmlHttp.onerror = () => {onFail('retrieve', xmlHttp)}
  xmlHttp.ontimeout = () => {onFail('timeout', xmlHttp)}

  xmlHttp.open("GET", url + (disableCaching ? '?' + new Date().getTime() : ''), true); // true for asynchronous 
  xmlHttp.send(null);
}


// WEBPACK FOOTER //
// ./src/utils/FileLoader.js